import { buildModelManager } from "../builder.js";
const DefaultShopifyDiscountSelection = {
  __typename: true,
  id: true,
  appDiscountType: true,
  appliesOnOneTimePurchase: true,
  appliesOnSubscription: true,
  appliesOncePerCustomer: true,
  asyncUsageCount: true,
  codesCount: true,
  combinesWith: true,
  createdAt: true,
  customerBuys: true,
  customerGets: true,
  destinationSelection: true,
  discountClass: true,
  discountId: true,
  endsAt: true,
  errorHistory: true,
  hasTimelineComment: true,
  maximumShippingPrice: true,
  minimumRequirement: true,
  recurringCycleLimit: true,
  shareableUrls: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  shortSummary: true,
  startsAt: true,
  status: true,
  summary: true,
  title: true,
  totalSales: true,
  type: true,
  updatedAt: true,
  usageLimit: true,
  usesPerOrderLimit: true
};
const modelApiIdentifier = "shopifyDiscount";
const pluralModelApiIdentifier = "shopifyDiscounts";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyDiscountSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyDiscountSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyDiscountSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyDiscount does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyDiscountManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyDiscountSelection,
  operations
);
export {
  DefaultShopifyDiscountSelection,
  ShopifyDiscountManager
};
//# sourceMappingURL=ShopifyDiscount.js.map
